// commons/context/ApiClientProvider.tsx
import { ReactNode } from 'react';
import type { ApiClient } from '../utils/apiHuappsUtils';
import { ApiClientContext } from './ApiClientContext';

type ApiClientProviderProps = {
  AppApi: ApiClient;
  HuappsApi: ApiClient;
  children: ReactNode;
};

export const ApiClientProvider = ({
  AppApi,
  HuappsApi,
  children,
}: ApiClientProviderProps) => {
  return (
    <ApiClientContext.Provider value={{ AppApi, HuappsApi }}>
      {children}
    </ApiClientContext.Provider>
  );
};
